export default __webpack_public_path__ + "static/media/split-path-challenge.0041811a.png";